import { render, staticRenderFns } from "./cernoYYZZ.vue?vue&type=template&id=2d8d5e12&scoped=true"
import script from "./cernoYYZZ.vue?vue&type=script&lang=js"
export * from "./cernoYYZZ.vue?vue&type=script&lang=js"
import style0 from "./cernoYYZZ.vue?vue&type=style&index=0&id=2d8d5e12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8d5e12",
  null
  
)

export default component.exports